import { Grid } from '@mui/material';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { noValidPoliciesContactUsText } from '../../../Constants/Constants';
import { IconStateType } from '../../../types/type';
import ConfirmationHeader from '../ConfirmationHeader/ConfirmationHeader';

export default function NoValidPoliciesFound() {
  const headerContent = 'File or check a claim';

  return (
    <Box sx={{ width: '100%' }}>
      <Grid
        container
        sx={{
          width: '100%',
          maxWidth: '1280px',
          minWidth: '310px',
          margin: '0 auto',
        }}
      >
        <Grid item xs={12}>
          <ConfirmationHeader headerContent={headerContent} state={IconStateType.NONE}></ConfirmationHeader>
        </Grid>
        <Grid sx={{ marginTop: '20px' }} item xs={12}>
          <Typography variant="body1">{noValidPoliciesContactUsText}</Typography>
        </Grid>
      </Grid>
    </Box>
  );
}
